<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="班级名称">
                  <el-input style="width: 177px" v-model="queryForm.className"></el-input>
              </el-form-item>
              <el-form-item label="开班状态">
<!--                  <el-input  v-model="queryForm.isShow"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.isShow"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-option
                          label="开班"
                          :value="1"
                      > </el-option>
                      <el-option
                          label="闭班"
                          :value="0"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduClassList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduClass"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduClass(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduClass(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduClassList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduClassList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduClassList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="className"
        label="班级名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="classPic"
        label="班级图片"
        width="180"
      >
          <template scope="scope">
              <el-image
                  @click='updateSrcList(scope.row.coursePic)'
                  style='width: 80px; height: 80px'
                  :src='scope.row.classPic'
                  :preview-src-list='srcList'
              ></el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="classPrice"
        label="报名价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="originalPrice"
        label="班级原价"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="classIntro"-->
<!--        label="班级介绍"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="classContent"-->
<!--        label="班级详情"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="startDate"
        label="开班日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="endDate"
        label="闭班日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isShow"
        label="开班状态"
        width="180"
      >
          <template slot-scope="scope">
            {{ scope.row.isShow == 1 ? '开班' : '闭班' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="expireDay"
        label="过期天数"
        width="180"
      >
          <template slot-scope="scop">
              {{ scop.row.expireDay == 0 ? '永久' : scop.row.expireDay + '天' }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="signCount"
        label="报名人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="virtualCount"
        label="虚拟人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="commentCount"
        label="评论数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="viewCount"
        label="浏览数量"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="createTime"-->
<!--        label="创建时间"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="456"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="checkEduClassCourse(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">课程管理</span>
              </div>
              <div @click="addStudentCourse(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">学员管理</span>
              </div>
              <div @click="addOrderCourse(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">报名订单</span>
              </div>
            <div @click="checkEduClass(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduClass(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduClass(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduClassStates[eduClassState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduClass"
          ref="eduClassForm"
          :rules="rules"
          label-width="90px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="班级名称"
            prop="className"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClass.className"
              :disabled="eduClassState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="报名价格"
            prop="classPrice"
          >
            <el-input
                style="width: 177px;"
              size="small"
              v-model="eduClass.classPrice"
              :disabled="eduClassState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="班级原价"
            prop="originalPrice"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClass.originalPrice"
              :disabled="eduClassState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="开班日期"
            prop="startDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduClass.startDate"-->
<!--              :disabled="eduClassState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  v-model="eduClass.startDate"
                  style="width: 177px;"
                  :disabled="eduClassState == 'check'"
                  size="small"
                  format='yyyy-MM-dd'
                  value-format='yyyy-MM-dd'
                  type="date"
                  placeholder="选择开班日期"
              >
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="闭班日期"
            prop="endDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduClass.endDate"-->
<!--              :disabled="eduClassState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  v-model="eduClass.endDate"
                  style="width: 177px;"
                  :disabled="eduClassState == 'check'"
                  size="small"
                  format='yyyy-MM-dd'
                  value-format='yyyy-MM-dd'
                  type="date"
                  placeholder="选择闭班日期"
              >
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="开班状态"
            prop="isShow"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduClass.isShow"-->
<!--              :disabled="eduClassState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  :disabled="eduClassState == 'check'"
                  v-model="eduClass.isShow"
                  placeholder="请选择"
                  size="small"
              >
                  <el-option
                      label="开班"
                      :value="1"
                  > </el-option>
                  <el-option
                      label="闭班"
                      :value="0"
                  > </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="过期天数"
            prop="expireDay"
          >
            <el-input
              size="small"
              style="width: 177px;"
              placeholder="有效期(天)"
              v-model="eduClass.expireDay"
              :disabled="eduClassState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="报名人数"
            prop="signCount"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClass.signCount"
              :disabled="eduClassState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="虚拟人数"
            prop="virtualCount"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClass.virtualCount"
              :disabled="eduClassState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="评论数量"
            prop="commentCount"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClass.commentCount"
              :disabled="eduClassState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="浏览数量"
            prop="viewCount"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduClass.viewCount"
              :disabled="eduClassState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduClass.sort"-->
<!--              :disabled="eduClassState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduClassState == 'check'"
                  v-model="eduClass.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
            <el-form-item
                label="班级图片"
                prop="classPic"
            >
                <!--            <el-input-->
                <!--              size="small"-->
                <!--              v-model="eduClass.classPic"-->
                <!--              :disabled="eduClassState == 'check'"-->
                <!--            ></el-input>-->
                <div style="width: 177px;;display: flex;align-items: center;">
                    <el-input v-model="eduClass.coursePic" size="small" :disabled="eduClassState == 'check'"></el-input>
                    <el-button type="primary" :disabled="eduClassState == 'check'" size="small" style="margin-left: 2px;" @click="uploadImages()">上传图片
                        <el-upload action="" v-show="false" ref="uploads" class="avatar-uploader" :show-file-list="false"
                                   :http-request="uploadAvatar">
                            <el-button type="primary" size="small" class="as">上传</el-button>
                        </el-upload>
                    </el-button>
                </div>
            </el-form-item>
            <el-form-item
                label="班级介绍"
                prop="classIntro"
            >
                <el-input
                    size="small"
                    style="width: 37.5vw;"
                    v-model="eduClass.classIntro"
                    :disabled="eduClassState == 'check'"
                ></el-input>
            </el-form-item>
            <el-form-item
                label="班级详情"
                prop="classContent"
            >
                <el-input
                    size="small"
                    style="width: 37.5vw;"
                    type="textarea"
                    :rows="4"
                    v-model="eduClass.classContent"
                    :disabled="eduClassState == 'check'"
                ></el-input>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduClassState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>

<!--   查看课程   -->
      <el-drawer
          title="课程"
          :visible.sync="showCourse"
          direction="rtl"
          size="70%"
          :before-close="closeShowDialog">
          <EduClassCourse ref="educlasscourse"></EduClassCourse>
      </el-drawer>
      <!--   学员管理   -->
      <el-drawer
          title="学员管理"
          :visible.sync="showStudentDialog"
          direction="rtl"
          size="70%"
          :before-close="closeShowStudentDialog">
          <EduClassStudent ref="student"></EduClassStudent>
      </el-drawer>
      <!--   报名订单   -->
      <el-drawer
          title="报名订单"
          :visible.sync="showOrderDialog"
          direction="rtl"
          size="70%"
          :before-close="closeShowOrderDialog">
          <EduClassOrder ref="order"></EduClassOrder>
      </el-drawer>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import EduClassCourse from '@/components/edu/EduClassCourse.vue';
import ShopCardUse from '@/components/shop/ShopCardUse.vue';
import EduClassStudent from '@/components/edu/EduClassStudent.vue';
import EduClassOrder from '@/components/edu/EduClassOrder.vue';

export default {
    components: {
        EduClassOrder,
        EduClassStudent,
        ShopCardUse,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        EduClassCourse
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduClassList();
                    this.getEduClassList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduClassList();
                    this.getEduClassList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     className: '', //班级名称
                     classPic: '', //班级图片
                     classPrice: '', //报名价格
                     originalPrice: '', //班级原价
                     classIntro: '', //班级介绍
                     classContent: '', //班级详情
                     startDate: '', //开班日期
                     endDate: '', //闭班日期
                     isShow: '', //上架状态：0下架 1上架
                     expireDay: '', //过期天数（从购买后计算，0为永久不过期）
                     signCount: '', //报名人数
                     virtualCount: '', //虚拟人数
                     commentCount: '', //评论数量
                     viewCount: '', //浏览数量
                     sort: '', //排序
                },
                id: '',
                srcList: [''],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduClassState: 'add',
                eduClassStates: {
                    add: '新建班级',
                    check: '查看班级',
                    edit: '修改班级'
                },

                multipleSelection: [],
                eduClassList: [],
                eduClass: {
                    id: '', //ID
                    className: '', //班级名称
                    classPic: '', //班级图片
                    classPrice: '', //报名价格
                    originalPrice: '', //班级原价
                    classIntro: '', //班级介绍
                    classContent: '', //班级详情
                    startDate: '', //开班日期
                    endDate: '', //闭班日期
                    isShow: '', //上架状态：0下架 1上架
                    expireDay: '', //过期天数（从购买后计算，0为永久不过期）
                    signCount: 0, //报名人数
                    virtualCount: 0, //虚拟人数
                    commentCount: 0, //评论数量
                    viewCount: 0, //浏览数量
                    sort: 1, //排序
                },
                btnLoading: false,
                showCourse: false,
                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    className: [{ required: true, message: '班级名称不能为空', trigger: 'blur' }],
                    classPic: [{ required: true, message: '班级图片不能为空', trigger: 'blur' }],
                    classPrice: [{ required: true, message: '报名价格不能为空', trigger: 'blur' }],
                    originalPrice: [{ required: true, message: '班级原价不能为空', trigger: 'blur' }],
                    classIntro: [{ required: true, message: '班级介绍不能为空', trigger: 'blur' }],
                    classContent: [{ required: true, message: '班级详情不能为空', trigger: 'blur' }],
                    startDate: [{ required: true, message: '开班日期不能为空', trigger: 'blur' }],
                    endDate: [{ required: true, message: '闭班日期不能为空', trigger: 'blur' }],
                    isShow: [{ required: true, message: '开班状态', trigger: 'blur' }],
                    expireDay: [{ required: true, message: '过期天数(单位:天,0为永久)', trigger: 'blur' }],
                    signCount: [{ required: true, message: '报名人数不能为空', trigger: 'blur' }],
                    virtualCount: [{ required: true, message: '虚拟人数不能为空', trigger: 'blur' }],
                    commentCount: [{ required: true, message: '评论数量不能为空', trigger: 'blur' }],
                    viewCount: [{ required: true, message: '浏览数量不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                },
                showStudentDialog: false,
                showOrderDialog: false,
            };
        },
        created() {
            this.getEduClassList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            addStudentCourse(id){
                this.showStudentDialog = true;
                this.$nextTick(()=>{
                    this.$refs.student.init(id)
                })
            },
            closeShowStudentDialog(){
                this.showStudentDialog = false;
            },
            closeShowOrderDialog(){
                this.showOrderDialog = false;
            },
            addOrderCourse(id){
                this.showOrderDialog = true;
                this.$nextTick(()=>{
                    this.$refs.order.init(id)
                })
            },
            updateSrcList(src) {
                this.srcList[0] = src;
            },
            resetEduClassList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduClassList = [];
            },
            closeShowDialog(){
                this.showCourse = false;
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                    return;
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.eduClass.classPic = res.url;
                    }
                });
            },
            uploadImages(){
                this.$refs.uploads.$el.querySelector(".as").click()
            },
            resetDialog() {
                this.eduClassState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      className: '', //班级名称
                      classPic: '', //班级图片
                      classPrice: '', //报名价格
                      originalPrice: '', //班级原价
                      classIntro: '', //班级介绍
                      classContent: '', //班级详情
                      startDate: '', //开班日期
                      endDate: '', //闭班日期
                      isShow: '', //上架状态：0下架 1上架
                      expireDay: '', //过期天数（从购买后计算，0为永久不过期）
                    signCount: 0, //报名人数
                    virtualCount: 0, //虚拟人数
                    commentCount: 0, //评论数量
                    viewCount: 0, //浏览数量
                    sort: 1, //排序
                };
                this.getEduClassList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduClass = {
                      id: '', //ID
                      className: '', //班级名称
                      classPic: '', //班级图片
                      classPrice: '', //报名价格
                      originalPrice: '', //班级原价
                      classIntro: '', //班级介绍
                      classContent: '', //班级详情
                      startDate: '', //开班日期
                      endDate: '', //闭班日期
                      isShow: '', //上架状态：0下架 1上架
                      expireDay: '', //过期天数（从购买后计算，0为永久不过期）
                      signCount: '', //报名人数
                      virtualCount: '', //虚拟人数
                      commentCount: '', //评论数量
                      viewCount: '', //浏览数量
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduClassState == 'add') {
                    this.$refs.eduClassForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/class/add`,{ ...this.eduClass }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduClassList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduClassState == 'edit') {
                    this.$refs.eduClassForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/class/edit`,{ ...this.eduClass }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduClassList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduClass() {
                this.showDialog = true;
                this.eduClassState = 'add';
            },
            checkEduClassCourse(id){
                this.showCourse = true;
                this.id = id;
                this.$nextTick(()=>{
                    this.$refs.educlasscourse.init(id);
                })
            },
            checkEduClass(eduClassId) {
                console.log(eduClassId);
                this.currentEduClassId = eduClassId;

                this.getEduClassById();
                this.showDialog = true;
                this.eduClassState = 'check';
            },
            editEduClass(eduClassId) {
                console.log('eduClass', eduClassId);
                if (eduClassId) {
                    this.currentEduClassId = eduClassId;
                    this.getEduClassById();
                } else {
                    this.eduClass = { ...this.eduClass, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduClassState = 'edit';
            },
            deleteEduClass(eduClassId) {
                let ids = '';
                if (eduClassId) {
                    ids = eduClassId;
                } else {
                    ids = this.multipleSelection.map((eduClass) => eduClass.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/class/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduClassList();
                                this.getEduClassList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduClassList() {
                this.resetEduClassList();
                this.getEduClassList();
            },
            getEduClassList(query = {}) {
                this.loading = true;
                get(`/edu/class/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduClassList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduClassById() {
                get(`/edu/class/get`,{ id: this.currentEduClassId }).then((res) =>{
                    if(res.success){
                      this.eduClass = { ...this.eduClass, ...res.eduClass };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduClassList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/class/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/class/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/class/importData`,formData);
              this.refreshEduClassList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduClassList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduClassList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 177px;
    height: 177px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 177px;
    height: 177px;
    line-height: 177px;
    text-align: center;
}
.avatar {
    width: 177px;
    height: 177px;
    display: block;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>